import React, { useState, Component } from "react";
import Sidebar from "./tem-sidebar";
import CsvParse from "@vtex/react-csv-parse";
import _, { initial } from "lodash";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import AddIcon from "@material-ui/icons/Add";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import refresh_token from "./../../Global/refresh_token";
import Spinner from "./../../Global/Spinner";
import DarkButton from "./../../Global/DarkButton";
import GlobalApi from "./../../Global/index";
import uuid from "react-uuid";
import Colors from "./../../Global/colors";
import NoRecords from "./../../Global/NoRecords";
import ReadMoreReact from 'read-more-react';
import ReadMore from "./../../Global/ReadMore"
import { useHistory } from "react-router-dom";
var blank_template = [
  {
    id: uuid(),
    title: "Title Page",
    type: "fixed section",
    position: 1,
    status: "New",

    checklist: {
      template: { id: uuid() },
      list: [
        {
          id: "New-" + uuid(),
          title: "Conducted on",
          dataType: "DateTime",
          position: 1,
          status: "New",
          responseLibrary: [],
          mandatory: false,
          multiselection: false,
          condition: "",
          conditionValue: "",
          conditional: "no",
          parent: null,
          isopen: "no",
          conditionalList: [],
        },
        {
          id: "New-" + uuid(),
          title: "Prepared by",
          dataType: "Text field",
          position: 2,
          status: "New",
          responseLibrary: [],
          mandatory: false,
          multiselection: false,
          condition: "",
          conditionValue: "",
          conditional: "no",
          parent: null,
          isopen: "no",
          conditionalList: [],
        },
        {
          id: "New-" + uuid(),
          title: "Location",
          dataType: "Location",
          position: 3,
          status: "New",
          responseLibrary: [],
          mandatory: false,
          multiselection: false,
          condition: "",
          conditionValue: "",
          conditional: "no",
          parent: null,
          isopen: "no",
          conditionalList: [],
        },
      ],
    },
  },
  {
    id: uuid(),
    title: "Inspection",
    type: "section",
    position: 2,
    status: "New",
    checklist: {
      template: { id: uuid() },
      list: [
        {
          id: "New-" + uuid(),
          title: "",
          dataType: "Text field",
          position: 1,
          status: "New",
          responseLibrary: [],
          mandatory: false,
          multiselection: false,
          condition: "",
          conditionValue: "",
          conditional: "no",
          parent: null,
          isopen: "no",
          conditionalList: [],
        },
      ],
    },
  },
];
export default class templateeditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: [],
      packageDetails: null,
      searchText: "",
      loaderBtn: false,
      industries: [],
      selectedIndustry: null,
    };
  }
  componentDidMount() {
    this.props.showside();
  }
  componentWillMount() {
    //=======Temporary Setting==========//
    //if(localStorage.getItem('UserData')==null)
    //  {

    //  var data={"organization_id":"04620940-5ff5-4db4-a059-c2d46ff496c6",
    //  "refreshToken":"55gVeUpJFcpfJFenAcZPdEGS3VcJMqNIcc4B7yDLicTddjrEBl",
    //  "token":"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6ImZiZmRhYjMzLWU4YjYtNGQxZi04NjNjLTkyMGUyMGYzNzdjYyIsImVtYWlsIjoia2h1cnJhbUBza3lwb3RlbnRpYWwuY29tIiwiaWF0IjoxNTk1NDE0NTY2LCJleHAiOjE1OTYxMzQ1NjZ9.B29dx4xF32Yc1nbiDUC115s6uNoLlL7vRq5Hc5W89Vo",
    //  "user_id":"fbfdab33-e8b6-4d1f-863c-920e20f377cc"}
    //  localStorage.setItem('UserData',JSON.stringify(data))
    //  }
    //==================================//
    this.getTemplates();
    this.getPackageDetails();
    this.fetchIndusties();
  }
  history = useHistory();
  fetchIndusties = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    try {
      let req = await fetch(GlobalApi + "/Industry/get_all_industries", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      });

      let reqJson = await req.json();

      if (reqJson.status === "Success") {
        this.setState({ industries: reqJson.data });
      }
    } catch (err) {
      console.log(err);
    }
  };
  
  getPackageDetails = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      this.history.replace("/billing");
    } else {
      this.setState({ packageDetails: reqJson.package });
    }
   
  };

  handleNesting(data) {
    let x = [];

    data.map((v) => {
      x.push({
        Title: v.Title,
        InputType: v.InputType,
      });
    });

    return x;
  }

  handleData = (data) => {
    const groups = _.groupBy(data, "id");
    let initial = [];
    Object.keys(groups).map((value) => {
      let obj = {
        id: groups[value][0].id,
        TemplateTitle: groups[value][0].TemplateTitle,
        createdBy: groups[value][0].createdBy,
        Description: groups[value][0].Description,
        InnerDetails: this.handleNesting(groups[value]),
      };
      initial.push(obj);
    });
    this.setState({ rows: initial }, () => {});
  };
  getTemplates = async (templateId) => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }

    this.setState({ Btn: true });
    var params = {
      //organization_id:'408576c3-0471-467e-9f55-f4c44bb54c6e',
      organization_id: data.organization_id,
    };

    //var token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjIzMWM0YmUxLTU3NmItNDc3Yi05ZGZlLTIwMWYzYWQ0ZmM0ZCIsImVtYWlsIjoiYWJkdWxAZ21haWwuY29tIiwiaWF0IjoxNTk0NjMzMjkyLCJleHAiOjE1OTUzNTMyOTJ9.iJKptiq4-4RGC3PawMAjz2iSeUnGwWhIujgKZJD7zFA'
    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(GlobalApi + "/Template/get_all_public_templates?" + query, {
      method: "GET",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
    })
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          var result = res.data;
          var templateList = [];
          result.map((data) => {
            var template = {
              id: data.id,
              TemplateTitle: data.title,
              Description: data.description,
              industry_id: data.industry_id,
              createdBy: data.created_by,
            };
            templateList.push(template);
          });
          this.setState({ rows: templateList });
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
          }
        }
      })
      .catch((err) => {
        //alert(err)
        console.log(err, "error");
      });
  };

  handleBack = async (template) => {
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data.token == null) {
      return <Redirect to={"/signin"} />;
    }

    var user = data.user_id;
    var obj = {
      title: "Untitled Template",
      //organization_id:'408576c3-0471-467e-9f55-f4c44bb54c6e',
      organization_id: data.organization_id,
      description: "Add Description",
      status: "draft",
      created_by: user,
    };
    //var token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjIzMWM0YmUxLTU3NmItNDc3Yi05ZGZlLTIwMWYzYWQ0ZmM0ZCIsImVtYWlsIjoiYWJkdWxAZ21haWwuY29tIiwiaWF0IjoxNTk0NjMzMjkyLCJleHAiOjE1OTUzNTMyOTJ9.iJKptiq4-4RGC3PawMAjz2iSeUnGwWhIujgKZJD7zFA'
    var token = data.token;
    fetch(GlobalApi + "/Template/create_template", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log(res.data);
        if (res.status === "Success") {
          await fetch(GlobalApi + "/TemplateShare/create_template_share", {
            method: "post",
            headers: new Headers({
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            }),
            body: JSON.stringify({
              user_id: user,
              organization_id: res.data.organization_id,
              template_id: res.data.id,
              isOwner: true,
              isEditor: true,
            }),
          });
          await blank_template.map(async (section) => {
            // if (section.status == "New")
            await this.addSection(
              section.title,
              res.data.id,
              user,
              section.checklist.list,
              token,
              section.type,
              section.position
            );
          });
          // await this.setState({
          //   loader: false,
          //   IsNewTemplate: false,
          //   templateId: res.data.id,
          //   action: "edit",
          //   runned: true,
          // });

          setTimeout(async () => {
            this.setState({ templateId: res.data.id });
          }, 3000);
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            this.handleBack();
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  addSection = (title, template_id, user, checklist, token, type, position) => {
    var obj = {
      title: title,
      template_id: template_id,
      status: "active",
      created_by: user,
      type: type,
      position: position,
    };
    var token = token;
    fetch(GlobalApi + "/Section/create_section", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log(res.data);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          await checklist.map((item) => {
            //alert(JSON.stringify(item.responseLibrary.responses))
            // if (item.status == "New")
            this.addChecklistItem(
              item.title,
              res.data.id,
              user,
              item.position,
              item.dataType,
              token,
              item.responseLibrary,
              item.mandatory,
              item.multiselection,
              item.condition,
              item.conditionValue,
              item.conditional,
              item.parent,
              item.conditionalList,
              item.type,
              item.is_subquestion,
              item.subQustionList,
            );
          });

          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            this.addNewSection(title, template_id, user, checklist, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  addChecklistItem = (
    title,
    section_id,
    user,
    position,
    dataType,
    token,
    responseLibrary,
    mandatory,
    multiselection,
    condition,
    conditionValue,
    conditional,
    parent,
    conditionalList,
    type,
    is_subquestion,
    subQuestionList
  ) => {
    var obj = {
      title: title,
      section_id: section_id,
      status: "active",
      created_by: user,
      position: position,
      data_type: dataType,
      is_mandatory: mandatory,
      is_multiple_allowed: multiselection,
      condition: condition,
      condition_value: conditionValue,
      is_conditional: conditional,
      parent_id: parent,
      type: type,
      is_subquestion: is_subquestion,
    };
    var token = token;
    fetch(GlobalApi + "/CheckList/create_check_list", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log(res.data);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          if (dataType == "Custom" || dataType == "Global") {
            await responseLibrary.responses.map((r, index) => {
              this.addResponseLibrary(
                r.title,
                res.data.id,
                r.id,
                user,
                token,
                index == 0 ? true : false
              );
            });
          }
          //==================================================//
          //===================== Add Conditional checklist===============//
          if (conditional == "yes") {
            conditionalList.map((item) => {
              // if (item.status == "New")
              this.addChecklistItem(
                item.title,
                section_id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                res.data.id,
                item.conditionalList,
                item.type,
                item.is_subquestion,
                item.subQuestionList,
              );

              if (item.status == "changed" || item.status == "deleted")
                this.updateChecklistItem(
                  item.title,
                  section_id,
                  user,
                  item.position,
                  item.dataType,
                  token,
                  item.responseLibrary,
                  item.status,
                  item.id,
                  item.mandatory,
                  item.multiselection,
                  item.condition,
                  item.conditionValue,
                  item.conditional,
                  item.parent,
                  item.conditionalList,
                item.type,
                item.is_subquestion,
                item.subQuestionList,
                );
            });
          }

          if (is_subquestion == "yes") {
            subQuestionList.map((item) => {
              // if (item.status == "New")
              this.addChecklistItem(
                item.title,
                section_id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                res.data.id,
                item.conditionalList,
                item.type,
                item.is_subquestion,
                item.subQuestionList,
              );

              if (item.status == "changed" || item.status == "deleted")
                this.updateChecklistItem(
                  item.title,
                  section_id,
                  user,
                  item.position,
                  item.dataType,
                  token,
                  item.responseLibrary,
                  item.status,
                  item.id,
                  item.mandatory,
                  item.multiselection,
                  item.condition,
                  item.conditionValue,
                  item.conditional,
                  item.parent,
                  item.conditionalList,
                item.type,
                item.is_subquestion,
                item.subQuestionList,
                );
            });
          }


          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            this.addChecklistItem(
              title,
              section_id,
              user,
              position,
              dataType,
              token,
              responseLibrary,
              mandatory,
              multiselection,
              condition,
              conditionValue,
              conditional,
              parent,
              conditionalList,
              type,
              is_subquestion,
              subQuestionList
            );
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  addResponseLibrary = (title, check_id, response_id, user, token, status) => {
    var obj = {
      title: title,
      check_id: check_id,
      response_id: response_id,
      status: "active",
      created_by: user,
      delete: status,
    };
    var token = token;
    fetch(GlobalApi + "/ResponseSet/create_response_set", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log(res.data);
        if (res.status === "Success") {
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            this.addResponseLibrary(title, check_id, response_id, user, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  render() {
    if (localStorage.getItem("UserData") === null) {
      return <Redirect to={"/signin"} />;
    }
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data.token == null) {
      return <Redirect to={"/signin"} />;
    }

    if (this.state.templateId) {
      return (
        <Redirect
          to={{
            pathname: "/show",
            state: { action: "edit", templateId: this.state.templateId },
          }}
        />
      );
    }

    const keys = [
      "id",
      "TemplateTitle",
      "createdBy",
      "Description",
      "InputType",
      "Title",
    ];

    let { packageDetails } = this.state;
    if (packageDetails?.license.status === "expired" || packageDetails?.license.status === "deactive") {
      return <Redirect to={"/billing"} />;
    }

    const list =
      this.state.rows.length !== 0 ? (
        this.state.rows
          .filter((v) => v.industry_id === this.state.selectedIndustry)
          .filter((v) =>
            v.TemplateTitle?.toLowerCase().includes(
              this.state.searchText?.toLowerCase()
            )
          )
          .map((index) => {
            return (
              <Paper
                variant="outlined"
                style={{ padding: 10, margin: 5 }}
                className="new-hover"
                key={index.id}
              >
                <Grid container>
                  <Grid item xs={9}>
                    <b>{index.TemplateTitle}</b>
                    <br />
                    <i> 
                      {/* <ReadMoreReact text={yourTextHere}
            min={minimumLength}
            ideal={idealLength}
            max={maxLength}
            readMoreText={readMoreText}/>
            {index.Description} */}
            <ReadMore text={index.Description} />
            </i>
                  </Grid>
                  <Grid item xs={3} align="right">
                    <Sidebar
                      id={index.id}
                      title={index.TemplateTitle}
                      description={index.Description}
                      // Panel={index.InnerDetails}
                      isDisabled={
                        packageDetails?.template_limit == packageDetails?.template_count ||
                        this.props.permissions !== true
                      }
                    />
                  </Grid>
                </Grid>
              </Paper>
            );
          })
      ) : (
        <NoRecords />
      );

    if (packageDetails !== null) {
      // if(this.state.rows.length == 0) {
      //   return "Loading..."
      // }
      return (
        <Container style={{ marginTop: 20, marginBottom: 10 }}>
          <Grid container alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                variant="h5"
                style={{ color: Colors.buttonTextColor, fontWeight: "bold" }}
              >
                {packageDetails?.template_count +
                  "/" +
                  (packageDetails?.template_limit === "Unlimited"
                    ? "~"
                    : packageDetails?.template_limit) +
                  " Templates have been created"}
              </Typography>
            </Grid>
            <Grid item xs={12} md={6} align="right">
              {(packageDetails?.template_limit != "Unlimited" ? (
                parseInt(packageDetails.template_limit) > parseInt(packageDetails.template_count)
              ) : (
                true
              )) ? (
                ""
              ) : (
                <Link to="/update_package">
                  <Button
                    // autoFocus
                    onClick={null}
                    style={{
                      marginTop: "10px",
                      marginRight: "1em",
                      marginBottom: "20px",
                      background: "#043077", color: "white" 
                    }}
                  >
                    Upgrade package
                  </Button>
                </Link>
              )}
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12}>
              {packageDetails?.template_limit != packageDetails?.template_count &&
              this.props.permissions === true ? (
                // <Link to={{ pathname: "/show", state: { action: "new" } }}>
                <div
                  className="blank-temp "
                  onClick={() => {
                    console.log(this.state.loaderBtn);
                    if (this.state.loaderBtn == false) {
                      this.handleBack();
                      this.setState({ loaderBtn: true });
                    }
                  }}
                >
                  <AddIcon style={{ cursor: "pointer" }} className="add-icon" />
                  <br />

                  <span style={{ cursor: "pointer" }}>
                    {this.state.loaderBtn == true
                      ? "Please Wait..."
                      : "Blank Template"}
                  </span>
                </div>
              ) : (
                // </Link>
                <div className=" blank-temp ">
                  <AddIcon style={{ cursor: "pointer" }} className="add-icon" />
                  <br />

                  {this.props.permissions === false ? (
                    <span style={{ cursor: "pointer" }}>Not Permitted</span>
                  ) : (
                    <span style={{ cursor: "pointer" }}>Blank Template</span>
                  )}
                </div>
              )}
            </Grid>
            {/* <Grid item xs={6}>
              <div className=" upload">
                <CsvParse
                  keys={keys}
                  onDataUploaded={this.handleData}
                  onError={this.handleError}
                  render={(onChange) => (
                    <form action="#">
                      <div class="file-field input-field">
                        <div class="btn">
                          <span>Upload CSV</span>
                          <input type="file" onChange={onChange} />
                        </div>
                        <div class="file-path-wrapper">
                          <input class="file-path validate" type="text" />
                        </div>
                      </div>
                    </form>
                  )}
                />
              </div>
            </Grid> */}
          </Grid>
          {/* <h6 className="left-align">Need inspiration?</h6> */}
          <h5
            className="left-align"
            style={{ color: Colors.buttonTextColor, fontWeight: "bold" }}
          >
            Find & customize a template from the public library
          </h5>

          {this.state.selectedIndustry !== null && (
            <Grid container style={{ padding: 10 }}>
              <Grid item xs={6}>
                <TextField
                  id="standard-basic"
                  placeholder="Search"
                  aria-label="Search"
                  fullWidth
                  autoComplete="off"
                  value={this.state.searchText}
                  onChange={(e) =>
                    this.setState({ searchText: e.target.value })
                  }
                />
              </Grid>
              <Grid item xs={6} align="right">
                <DarkButton
                  onClick={() => this.setState({ selectedIndustry: null })}
                >
                  Go Back
                </DarkButton>
              </Grid>
            </Grid>
          )}

          {this.state.selectedIndustry === null ? (
            <Container>
              <Grid
                container
                spacing={2}
                // justify="center"
                // alignItems="center"
                // justifyContent="center"
              >
                {this.state.industries.map((item) => {
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={3}
                      align="center"
                      style={{ textAlign: "center" }}
                    >
                      <Paper
                        variant="outlined"
                        style={{ padding: 5 }}
                        className="cursor new-hover"
                        onClick={() =>
                          this.setState({ selectedIndustry: item.id })
                        }
                      >
                        <Grid container>
                          <Grid item xs={12}>
                            <img
                              style={{ width: "100%" }}
                              src={Colors.fileUrl + item.image}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <Typography
                              variant="p"
                              style={{ fontSize: "1rem" }}
                            >
                              {item.title}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                  );
                })}
              </Grid>
            </Container>
          ) : (
            list
          )}
        </Container>
      );
    } else {
      return <Spinner />;
    }
  }
}
